export function resolveHotelSessionId(roomPricingSessionId: string | undefined): string {
  return (roomPricingSessionId ?? "") as string;
}
